export const SET_NIGHT_THEME_FULFILLED = 'SET_NIGHT_THEME_FULFILLED';
export const SET_DAY_THEME_FULFILLED = 'SET_DAY_THEME_FULFILLED';
